export const userName = 'User';
export const passwordName = 'Password';
export const bearer = 'Bearer';
export const apiUrl = '/api/';
export const allOption = 'All';
export const orderNowForPickupTomorrow = 'Order now for pickup tomorrow';
export const orderNowForPickupWhenOpen = 'Order now for pickup after opening';
export const onlineOrderingUnavailable = 'Ordering online is currently not available';
export const proceedToPayment = 'Proceed to payment';
export const placeOrder = 'Place order';